import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowNumber } from "../../../common/controls";
import { ShowMultiLine } from "../../../common/controls";
import { ShowDateTime } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { CrudRows } from "../../../common/types";
import { ShowFilesCompact } from "../../../common/controls";
import { IMenuAction } from "../../../../common/controls";
import { FormControl } from "@mui/material";

export type BotStepViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  stepNumberValue?: { displayId: string; id: string } | null;
  stepNumber: number;
  stepIdValue?: { displayId: string; id: string } | null;
  stepId: string;
  statusValue?: { displayId: string; id: string } | null;
  status: string;
  startedAtValue?: { displayId: string; id: string } | null;
  startedAt: Date | null;
  completedAtValue?: { displayId: string; id: string } | null;
  completedAt: Date | null;
  durationValue?: { displayId: string; id: string } | null;
  duration: number | undefined;
  errorValue?: { displayId: string; id: string } | null;
  error: string;
  downloadedFileFiles: CrudRows;
  downloadedFileViewAction?: IMenuAction[];
};

export const BotStepViewForm: React.FC<BotStepViewFormProps> = observer(
  ({
    onPrint = () => {},
    onCancel = () => {},
    onEdit,
    showToolbox = true,
    stepNumber = 0,
    stepId = "",
    status = "",
    startedAt = null,
    completedAt = null,
    duration = 0,
    error = "{}",
    downloadedFileFiles,
    downloadedFileViewAction,
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            editForm={onEdit}
            printForm={() => onPrint(handlePrint)}
            closeForm={() => onCancel()}
          />
        )}
        <Box ref={componentRef}>
          <GroupContainer
            id="null"
            title={langStore.groupBotStepLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <ShowNumber
                value={stepNumber}
                label={langStore.BotStepStepNumberLabel}
              />
              <ShowMultiLine
                value={stepId}
                label={langStore.BotStepStepIdLabel}
              />
              <ShowMultiLine
                value={status}
                label={langStore.BotStepStatusLabel}
              />
              <ShowDateTime
                value={startedAt}
                label={langStore.BotStepStartedAtLabel}
              />
              <ShowDateTime
                value={completedAt}
                label={langStore.BotStepCompletedAtLabel}
              />
              <ShowNumber
                value={duration}
                label={langStore.BotStepDurationLabel}
              />
              <InputCodeEditor
                value={error}
                onChange={() => {}}
                label={langStore.BotStepErrorLabel}
                language="json"
                readOnly={true}
              />
              <ShowFilesCompact
                rows={downloadedFileFiles}
                showLabel={true}
                label={langStore.BotStepDownloadedFileLabel}
                menuActions={downloadedFileViewAction}
                columns={[
                  { name: "mimetype", title: langStore.fileTypeLabel },
                  { name: "name", title: langStore.fileNameLabel },
                  { name: "formattedSize", title: langStore.fileSizeLabel },
                ]}
              />
            </FormControl>
          </GroupContainer>
        </Box>
      </Grid>
    );
  }
);
